import styled from 'styled-components';
import { Backdrop, Button, Card, Paper } from '@material-ui/core';
import { diffuseGlass } from 'styles/mixins';

export const StyledSidebarLogosContainer = styled(Card)`
    margin-top: 20px;
    padding: ${({ theme }) => theme.spacing(1, 1)};
    ${diffuseGlass}
`;

export const StyledDivDesktop = styled.div`
    position: absolute;
    top: 50%;
    left: 20px;
    z-index: 200;
    width: 220px;
    transform: translateY(-50%);
`;

export const StyledDivMobile = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
`;

export const StyledSidebar = styled(Card)`
    padding: ${({ theme }) => theme.spacing(0, 2)};
    ${diffuseGlass}
`;

export const StyledBackdrop = styled(Backdrop)`
    z-index: ${({ theme }) => theme.zIndex.modal - 1};
`;

export const StyledPaper = styled(Paper)`
    position: absolute;
    top: 50%;
    z-index: ${({ theme }) => theme.zIndex.modal};
    width: auto;
    max-width: 360px;
    margin: ${({ theme }) => theme.spacing(0, 5)};
    padding: ${({ theme }) => theme.spacing(0, 3)};
    transform: translateY(-50%);
`;

export const StyledButton = styled(Button)`
    position: absolute;
    z-index: 200;
    ${diffuseGlass}
`;
